import { Moment } from "moment";
import { useField } from "formik";
import React, { useMemo } from "react";

import { TimePicker, TimePickerProps } from "../ui/TimePicker";
import { FieldContainer, FieldContainerProps } from "./FieldContainer";

interface Props extends TimePickerProps {
  readonly name: string;
  readonly label?: string;
  onChange?: (newValue: Moment) => void;
  readonly fieldProps?: Omit<FieldContainerProps, "label" | "children">;
}

export function TimeField({ name, label, fieldProps, ...props }: Props) {
  const [field, meta, helpers] = useField(name);

  const error = useMemo(() => {
    if (meta.touched && meta.error) {
      return meta.error;
    }
  }, [meta.error, meta.touched]);

  return (
    <FieldContainer
      {...fieldProps}
      label={label}
      error={Boolean(error)}
      hintText={error || fieldProps?.hintText}
    >
      <TimePicker
        {...props}
        {...field}
        onChange={(x) => {
          helpers.setValue(x);

          if (props.onChange) {
            props.onChange(x);
          }
        }}
      />
    </FieldContainer>
  );
}
